import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';

import useBarcodeScanner from '../../utils/useBarcodeScanner';

/**
 * Повноекранний сканер штрих-кодів.
 *
 * Раніше це був чужий компонент із <Webcam> усередині, який нічого не знав
 * про стан дозволів: якщо касир відхилив доступ до камери або застосунок
 * відкрили не по HTTPS, екран просто лишався чорним без жодного пояснення.
 */
const BarcodeScanner = ({ visible, onHide, onDetect, busy = false }) => {
    const { videoRef, status, error, torch, toggleTorch } = useBarcodeScanner({
        active: visible,
        onDetect,
    });

    return (
        <Sidebar visible={visible} onHide={onHide} fullScreen className="rc-scanner">
            <div className="rc-scanner__stage">
                <video
                    ref={videoRef}
                    className="rc-scanner__video"
                    playsInline
                    muted
                    autoPlay
                />

                {status === 'scanning' && (
                    <>
                        <div className="rc-scanner__frame" aria-hidden="true" />
                        <div className="rc-scanner__hint">
                            {busy
                                ? 'Шукаємо товар…'
                                : 'Наведіть рамку на штрих-код — розпізнається автоматично'}
                        </div>
                    </>
                )}

                {status === 'starting' && (
                    <div className="rc-scanner__overlay">
                        <i className="pi pi-spin pi-spinner" />
                        <p>Вмикаємо камеру…</p>
                    </div>
                )}

                {status === 'error' && error && (
                    <div className="rc-scanner__overlay">
                        <i className="pi pi-video" />
                        <p className="rc-scanner__overlay-title">{error.title}</p>
                        <p className="rc-scanner__overlay-text">{error.detail}</p>
                    </div>
                )}

                <div className="rc-scanner__actions">
                    {torch.supported && (
                        <Button
                            type="button"
                            icon={torch.on ? 'pi pi-lightbulb' : 'pi pi-lightbulb'}
                            label={torch.on ? 'Вимкнути ліхтарик' : 'Ліхтарик'}
                            rounded
                            severity="secondary"
                            onClick={toggleTorch}
                        />
                    )}
                    <Button
                        type="button"
                        icon="pi pi-times"
                        label="Закрити"
                        rounded
                        severity="secondary"
                        onClick={onHide}
                    />
                </div>
            </div>
        </Sidebar>
    );
};

export default BarcodeScanner;
